import { ErrorOutlineRounded } from '@mui/icons-material'
import dayjs from 'dayjs'
import { OrderCard } from 'feature/appeals/components/Order/OrderCard'
import { getArrayOfAppealParameters } from 'feature/appeals/helpers/getArrayOfAppealParameters'
import { stateCurrentAppeal } from 'feature/appeals/redux/appealFormCreateSelector'
import { useGetAppealQuery } from 'feature/appeals/redux/appeals.api'
import { TEditAppealRequest } from 'feature/appeals/type'
import { InformationCard } from 'feature/informationCard'
import { useEffect, useRef, useState } from 'react'
import { Navigate, useParams, useSearchParams } from 'react-router-dom'
import useRequestTimeout from 'router/hooks/useRequestTimeout'
import { useActions, useAppSelector } from 'store/hooks'
import { LoaderInCentalPosition } from 'widget'

type TAppealsDetail = {
  type: 'order' | 'lead'
}

// детальная страница заявки
export function AppealsDetail({ type }: TAppealsDetail) {
  const [isRequestWithError, setRequestWithError] = useState<boolean>(false)
  const params = useParams()
  const [queryParameters] = useSearchParams()
  const { isTimeUp, Modal } = useRequestTimeout()
  const { setAppeal, setAppealType, setAppealStatus } = useActions()
  const { isPullingStopped } = useAppSelector(stateCurrentAppeal)

  const canSetAppeal = useRef(true)

  const uidSearchParameters = Number(queryParameters.get('uid'))
  const uid = type === 'order' ? uidSearchParameters : Number(params.leadId)
  const isSkipPolling = isTimeUp || isRequestWithError || isPullingStopped
  setAppealType(type)

  const { data, isLoading, isError } = useGetAppealQuery(
    {
      uid: uid,
      orderId: params.orderId || '',
    },
    {
      pollingInterval: 10000,
      skip: isSkipPolling,
    },
  )

  useEffect(() => {
    if (isError) setRequestWithError(isError)
  }, [isError])

  useEffect(() => {
    if (data?.status.status) {
      setAppealStatus(data?.status.status)
    }
  }, [data?.status.status])

  //добавляю пришедшие данные в стейт
  useEffect(() => {
    if (data && canSetAppeal) {
      const appeal: TEditAppealRequest = {
        uid: data.uid,
        orderId: data.orderIdList[0],
        products: data.products.map(product => ({
          id: product.id,
          parameters: getArrayOfAppealParameters(product.parameters),
        })),
        location: data.location,
        timeSlots: data?.timeSlots?.map(slot => ({
          id: slot.id as number,
          date: dayjs(slot.dateFrom)
            .startOf('day')
            .format('YYYY-MM-DDTHH:mm:ss'),
        })),
      }

      setAppeal(appeal)
      canSetAppeal.current = false
    }
  }, [data])

  // редирект если у лида несколько сделок
  if (data && data?.orderIdList?.length > 1) {
    return <Navigate to='/appeals' replace={true} />
  }
  // если у лида уже есть заказ - редирект на него
  if (data && params.leadId && data?.orderIdList.length) {
    return (
      <Navigate
        to={`/appeals/order/${data?.orderIdList[0]}?uid=${params.leadId}`}
        replace={true}
      />
    )
  }

  // OrderCard не поддерживает тип CONSULTATION - для него отдельная страница
  if (data && data.type === 'CONSULTATION') {
    return <Navigate to={`/appeals/consultation/${data.uid}`} replace={true} />
  }

  if (isLoading) {
    return <LoaderInCentalPosition />
  }

  if (!data)
    return (
      <InformationCard
        title='заказ не найден'
        subtitle='Возможно, загруженная ссылка некорректна'
        Icon={<ErrorOutlineRounded fontSize='large' color='primary' />}
        link='/appeals'
        linkText='Мои обращения'
      />
    )

  return (
    <>
      <OrderCard data={data} />
      {Modal}
    </>
  )
}
